import { AccessibilityService } from '@shared/services';
import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  ViewChild,
  AfterContentChecked,
  inject
} from '@angular/core';
import { UserRoleService } from '@usermanagement/services';
import { SelectItem } from 'primeng/api';
import { Select } from 'primeng/select';

@Component({
  selector: 'app-school-list',
  templateUrl: './school-list.component.html',
  standalone: false
})
export class SchoolListComponent implements OnInit, AfterContentChecked {
  private readonly userService = inject(UserRoleService);
  private readonly accessibilityService = inject(AccessibilityService);

  public isDataLoadedforSchools;
  public selectedSchoolGroup: SelectItem;
  public schoolGroup: SelectItem[] = [];
  public isFilterable: boolean;
  public schoolId: number;
  public schoolName: string;

  @ViewChild('dropdownSchoolList') dropdownSchoolList: Select;
  @Output() schoolChanged: EventEmitter<SelectItem> =
    new EventEmitter<SelectItem>();
  @Input() headerText: string;
  ngOnInit(): void {
    if (
      this.userService.isSchoolAdmin &&
      this.userService.schoolUserContextId != null
    ) {
      this.setSchoolGroup();
    } else {
      this.userService.userInfoReceived.subscribe((x) => {
        if (this.userService.isSchoolAdmin) {
          this.isFilterable = false;
          if (x) {
            this.setSchoolGroup();
          }
        }
      });
    }
    setTimeout(() => {
      if (this.dropdownSchoolList) {
        this.dropdownSchoolList.focus();
      }
    }, 0);
  }

  public setSchoolContext() {
    this.userService.setSchoolContext(this.selectedSchoolGroup.value);
    this.schoolChanged.emit(this.selectedSchoolGroup);
  }

  private setSchoolGroup(): void {
    this.schoolGroup = [];
    this.userService.User.schools.forEach((element) => {
      this.schoolGroup.push({
        label: element.schoolName,
        value: element.schoolId
      });
    });

    if (this.userService.User.schools.length > 0) {
      this.getsingleSchoolName();
      this.schoolGroup.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
    }

    this.isDataLoadedforSchools =
      this.userService.User.schools.length > 1 ? true : false;

    if (
      this.userService.schoolUserContextId !== undefined &&
      this.userService.schoolUserContextId !== null
    ) {
      this.selectedSchoolGroup =
        this.schoolGroup[
          this.schoolGroup.findIndex(
            (x) => x.value === this.userService.schoolUserContextId
          )
        ];
    } else {
      this.selectedSchoolGroup = this.schoolGroup[0];
    }
    this.schoolChanged.emit(this.selectedSchoolGroup);
  }

  private getsingleSchoolName() {
    if (this.userService.User.schools.length === 1) {
      this.headerText += ' ' + this.userService.User.schools[0].schoolName;
    }
  }

  ngAfterContentChecked(): void {
    const props = new Map<string, string>();
    props.set('title', 'School names');
    this.accessibilityService.setDropDownItemsAttributes(
      this.dropdownSchoolList,
      props
    );

    const attributeMap = new Map();
    attributeMap.set('aria-label', 'School names');
    this.accessibilityService.setDropDownLabelAttributes(
      this.dropdownSchoolList,
      attributeMap
    );

    this.setAccessibleNameForSchoolList();
    this.setLandmarkRoleForDropdowns();
    this.setTabindexInScrollableRegionForDropdDowns();
    this.removeRoleAttributeForDropDowns();
    this.removeAriaExpandedAttributeForDropDowns();
  }

  private setAccessibleNameForSchoolList() {
    if (this.dropdownSchoolList) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.dropdownSchoolList,
        'Select school'
      );
    }
  }

  // Ensures all page content is contained by landmarks
  private setLandmarkRoleForDropdowns() {
    if (this.dropdownSchoolList) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.dropdownSchoolList
      );
    }
  }

  // Ensure elements that have scrollable content are accessible by keyboard
  private setTabindexInScrollableRegionForDropdDowns() {
    if (this.dropdownSchoolList) {
      this.accessibilityService.setTabindexInScrollableRegionForDropdDown(
        this.dropdownSchoolList
      );
    }
  }

  // Ensures role attribute has an appropriate value for the element
  private removeRoleAttributeForDropDowns() {
    if (this.dropdownSchoolList) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.dropdownSchoolList
      );
    }
  }

  // Remove aria -expanded attribute
  private removeAriaExpandedAttributeForDropDowns() {
    if (this.dropdownSchoolList) {
      this.accessibilityService.removeAriaExpandedAttribute(
        this.dropdownSchoolList
      );
    }
  }
}
